module.exports = __webpack_public_path__ + "img/9788952746177.e70bd361.jpg";